/** Copyright (c) 2017 T. Rowe Price. All rights reserved. */

import './InterceptMessageModal.scss';

import classnames from 'classnames';
import { isEmpty } from 'lodash';
import React from 'react';
import { connect } from 'react-redux';

import BaseModal from 'components/shared/Modal/BaseModal';
import { suppressIRTMessage } from 'services/Rest';
import { contentConverter } from 'services/Content';
import {
  isIrtMessagesNotPriority,
  hasDataForIrtMessagesAndCMMModals
} from 'state/view/ViewSelectors';
import {
  getInterceptMessage,
  getInterceptIsTourModal
} from 'state/IRT/IRTMessagesSelectors';
import { hasSeenIrtMessage } from 'state/IRT/IRTMessagesActions';
import StartATourModal from 'components/layouts/StartATourModal/StartATourModal';
import { getShowConsentModal } from 'state/external/ExternalInvestmentConsentSelectors';
import Store from 'state/Store';
import WithUserPermissions from 'components/shared/WithUserPermissions/WithUserPermissions';
import ActionButton from 'components/shared/Buttons/ActionButton';

const CMM_SESSION_STORAGE_ID = 'seenCMM';
const hasSeenCMM = JSON.parse(sessionStorage.getItem(CMM_SESSION_STORAGE_ID));
const ActionButtonWithPermissions = WithUserPermissions(ActionButton);

class InterceptMessageModal extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      showModal: false,
      suppressMessage: false
    };
  }

  componentDidMount() {
    const { interceptMessage } = this.props;
    this.setState({
      showModal: !interceptMessage.viewed
    });
  }

  componentDidUpdate(prevProps, prevState) {
    const { hasCmmAndIrt } = this.props;
    const { showModal } = this.state;
    const seenCMM = JSON.parse(sessionStorage.getItem(CMM_SESSION_STORAGE_ID));
    if (hasCmmAndIrt && seenCMM && showModal !== prevState.showModal) {
      this.setState({ showModal: false });
    }
  }

  handleSuppress = () => {
    this.setState(
      (prevState) => ({
        suppressMessage: !prevState.suppressMessage
      }),
      () => {
        this.closeModal();
      }
    );
  };

  closeModal = () => {
    const { interceptMessage, isTourModal } = this.props;
    const { suppressMessage } = this.state;

    Store.dispatch(hasSeenIrtMessage(interceptMessage));
    this.setState({ showModal: false });

    if (suppressMessage || isTourModal) {
      const { messageId = null } = interceptMessage;
      if (messageId) {
        suppressIRTMessage(messageId);
      }
    }
  };

  render() {
    const {
      isIrtMessagesNotPriority,
      interceptMessage,
      isTourModal,
      isMobileLayout,
      showConsentModal
    } = this.props;
    const { showModal } = this.state;
    const {
      imageUrl = '',
      messageSummary = '',
      messageText = ''
    } = interceptMessage;

    const hasImageOrText =
      !isEmpty(imageUrl) || !isEmpty(messageSummary) || !isEmpty(messageText);

    const className = classnames('intercept-message-container', {
      'non-priority-modal-disabled': isIrtMessagesNotPriority && !hasSeenCMM
    });

    return showModal && hasImageOrText && !isTourModal && !showConsentModal ? (
      <BaseModal
        containerClassName={className}
        isOpen={showModal && hasImageOrText}
        title={messageSummary}
        hideClose={true}
        label="intercept-message-modal"
        disableClickOff
        hideAnchor>
        <div className="intercept-message-modal-content">
          {!isEmpty(imageUrl) && (
            <img
              alt={imageUrl}
              className="intercept-message-modal-image"
              src={imageUrl}
            />
          )}
          {!isEmpty(messageText) && (
            <div
              className="intercept-message-modal-body"
              dangerouslySetInnerHTML={{
                __html: contentConverter.makeHtml(messageText)
              }}
            />
          )}
        </div>
        <div className="intercept-message-modal-footer">
          <ActionButtonWithPermissions
            onClick={this.handleSuppress}
            id="suppressIrtMessageId"
            className="suppress-irt-message"
            shouldDisable>
            Don&apos;t show again
          </ActionButtonWithPermissions>
          <ActionButton
            onClick={this.closeModal}
            id="closeIrtMessageId"
            className="close-irt-message">
            Close
          </ActionButton>
        </div>
      </BaseModal>
    ) : showModal && hasImageOrText && isTourModal && !isMobileLayout ? (
      <StartATourModal
        showModal={showModal && hasImageOrText}
        closeModal={this.closeModal}
        isIrtMessagesNotPriority={isIrtMessagesNotPriority}
      />
    ) : null;
  }
}

const mapStateToProps = (state) => ({
  isIrtMessagesNotPriority: isIrtMessagesNotPriority(state),
  interceptMessage: getInterceptMessage(state),
  isTourModal: getInterceptIsTourModal(state),
  isMobileLayout: state.view.isMobileLayout,
  hasCmmAndIrt: hasDataForIrtMessagesAndCMMModals(state),
  showConsentModal: getShowConsentModal(state)
});

export default connect(mapStateToProps)(InterceptMessageModal);
